var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.inquiryName)?_c('div',{staticClass:"ui bottom left attached label"},[_vm._v(" "+_vm._s(_vm.inquiryName)+" ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }